module.exports = __webpack_public_path__ + "media/app-icons/Inspections_Surveys-91681588.svg";